import { useAuth } from 'auth'
import { ReactNode, createContext, useContext } from 'react'

const ActiveUserContext = createContext<boolean | undefined>(undefined)

export const useActiveUser = () => {
  const context = useContext(ActiveUserContext)
  if (context === undefined) {
    throw new Error(
      'useOnlineStatus must be used within an OnlineStatusProvider'
    )
  }
  return context
}
interface ActiveUserProviderProps {
  children: ReactNode
}

export const ActiveUserProvider: React.FC<ActiveUserProviderProps> = ({
  children
}) => {
  const { activeUser } = useAuth()
  return (
    <ActiveUserContext.Provider value={activeUser}>
      {children}
    </ActiveUserContext.Provider>
  )
}
